class Job {
  constructor(job) {
    if (job.specs === undefined) {
      job.specs = {};
    }
    // eslint-disable-next-line
    this.id = job._id;
    this.ownerId = job.ownerId;
    this.ownerName = job.owner_name;
    this.guid = job.guid;
    this.dateAdded = new Date(job.date_added);
    this.status = job.status;
    if (job.date_completed) {
      this.dateCompleted = new Date(job.date_completed);
    }
    this.detailedStatus = null; // used for when job creation is currently pending
    this.title = job.title;
    this.tags = job.tags || [];
    this.subtitles = Object.assign(
      {},
      { started: false, finished: false, progress: 0 },
      job.subtitles
    );
    this.transcript = Object.assign({}, { started: false, finished: false }, job.transcript);
    this.cardType = job.specs ? job.specs.cardType : '';
    this.width = job.specs ? job.specs.width : null;
    this.height = job.specs ? job.specs.height : null;
    this.archived = job.archived || false;
    this.deleted = job.deleted || false;
    if (this.dateCompleted || this.status === 'complete') {
      this.url = `https://s3.amazonaws.com/sls-wavve-out/${job.guid}.mp4`;
    } else {
      this.url = null;
    }
    if (job.specs.backgroundImage) {
      this.backgroundImageKey = job.specs.backgroundImage;
      this.backgroundImage = `https://s3-us-west-2.amazonaws.com/wavvegram/background/${
        job.specs.backgroundImage
      }`;
    } else {
      this.backgroundImageKey = null;
      this.backgroundImage = null;
    }
    if (this.subtitles.ref) {
      this.captionUrl = `https://s3.amazonaws.com/subtitles-out/${this.subtitles.ref}`;
    } else {
      this.captionUrl = null;
    }
    // eslint-disable-next-line
    this.themeId = job.specs ? job.specs._id : -1;
    if (job.duration) {
      this.duration = +job.specs.duration;
    } else if (job.specs.start !== undefined && job.specs.end !== undefined) {
      this.duration = +job.specs.end - +job.specs.start;
    } else {
      this.duration = 0;
    }
  }
}

export default Job;
